<template>
  <div 
    class="event-list-container"
    ref="eventListContainer" >
    <div class="eventlist" ref="evlist">
      <template v-for="(key, inx) in sortedKeys" :key="key" >
        <div 
          :cday="this.sortedKeys[inx]"
          :ref="`currentDay${this.sortedKeys[inx]}`"
          class="daywrapper">
          <h2>{{ key }}</h2>
          <EventItem
            class="eventItem"
            :colorbackground="aulascolor[event.cadeira].body"
            :colorseparador="aulascolor[event.cadeira].header"
            :horaInicio="event.horaInicio"
            :horaFim="event.horaFim"
            :disciplina="event.cadeira"
            :tipo="event.tipo"
            :sala="event.sala_desc"
            :ano="event.ano"
            :turma="event.turma"
            :professor="event.docente"
            :piso="event.piso"
            :key="event.id"
            v-for="event in sortedCalendario[key]" />
        </div>
      </template>
      <p v-if="Object.keys(sortedCalendario).length === 0">
        <i class="ms-Icon ms-Icon--Warning" title="Warning" aria-hidden="true"></i> {{$t('semavaliacao')}}
      </p>
    </div>
  </div>
</template>

<script>
import EventItem from "./eventItem.vue";

export default {
  name: "EventList",
  props: [
    "aulascolor",
    "sortedCalendario",
    "sortedKeys",
  ],
  emits:["changeDay"],
  components: {
    EventItem
  },
};
</script>

<style scoped>
.daywrapper:not(:last-of-type){
  margin-bottom: 35px;
}

.event-list-container {
  height: calc(70vh);
  overflow-y: scroll;
}



.eventlist {
  padding-top: 10px;
  padding-bottom: 0px;
  padding-left: 10px;
  padding-right: 30px;
  width: 60%;
}

.eventItem {
  margin-bottom: 15px;
}

h2 {
  font-size: 14px;
  font-family: "Montserrat";
  text-transform: uppercase;
  margin-bottom: 20px;
}

p{
  font-size: 20px;
  font-family: "Montserrat";
}

.spacer {
  width: 100%;
}

.eventlist p i {
  font-size: 32px;
  padding-right: 10px;
  color: #0a0a0a;
}

.eventlist p {
    display: flex;
    font-family: "Montserrat";
    align-items: center;
    color: #0a0a0a;
    font-size: 18px;
 }




@media only screen and (max-width:1500px) {

  .eventlist {
    width: 80%;
  }

  

  }



  @media only screen and (max-width:1150px) {

  .eventlist {
    width: 100%;
  }

  

  }


@media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px)  {
  
  .eventlist{
    width: 100%;
  }      

  .event-list-container {
    height: calc(80vh);
  }


}


@media only screen and (max-width:1150px) {

   .eventlist p {
    font-size: 16px;
    padding-left: 25px;
  }

   .eventlist p i{
    font-size: 28px;
  }
  
  }

 @media only screen and (max-width:768px) {

  h2 {
    font-size: 11px;
  }

  

  }









</style>
